import { request } from '../index'

export function createNFe(data) {
    return request({ url: "nfe/", method: "POST", data })
}
export function previewNFe(data) {
    return request({ url: "nfe/preview/", method: "POST", data })
}
export function filterNFe(params, responseType = false) {
    if (responseType) {
        return request({ url: "nfe/", params, responseType })
    }
    return request({ url: "nfe/", params })
}
export function getPendingNotes(id) {
    return request({ url: "nfe/pending-notes/" })
}
export function consultNFe(id) {
    return request({ url: `nfe/${id}/has-pending/`, data: { id }, method: "POST" })
}
export function cancelNFe(id, params) {
    return request({ url: `nfe/${id}/cancel/`, method: "POST", params })
}
export function disableNFe(id, params) {
    return request({ url: `nfe/${id}/disable/`, method: "POST", params })
}
export function getNFeBase64(params) {
    return request({ url: "nfe/download/", params })
}
export function getNFeEvents(id) {
    return request({ "url": `nfe/${id}/events/` })
}
export function getNFeEventMaxSequence(id) {
    return request({ "url": `nfe/${id}/max-sequence/` })
}
export function createNFeEvent(id, data) {
    return request({ url: `nfe/${id}/event/`, method: "POST", data })
}

export function getNFeConfig() {
    return request({ url: "config/" })
}
export function getNFeHistory(id) {
    return request({ url: `nfe/${id}/history/` })
}
export function getNFeXMLAuth() {
    return request({ "url": "config/add-xml-auth/" })
}
export function createNFeXMLAuth(data) {
    return request({ "url": "config/add-xml-auth/", method: "POST", data })
}
export function deleteNFeXMLAuth(params) {
    return request({ "url": "config/add-xml-auth/", method: "DELETE", params })
}
export function correctNFeXMLAuth(data) {
    return request({ "url": "config/correct-xml-auth/", method: "POST", data })
}
export function updateNFeConfig(data) {
    return request({ url: `config/${data.id}/`, method: "PUT", data })
}
export function getNFeTransporters() {
    return request({ url: "nfe-transporter/" })
}
export function createTransporter(data) {
    return request({ url: "nfe-transporter/", data, method: "POST" })
}
export function updateTransporter(data) {
    return request({ url: `nfe-transporter/${data.id}/`, data, method: "PUT" })
}
export function adaptNFe(params) {
    return request({ url: "nfe/adapt/", params })
}
export function importNFeFromInvoicy(data) {
    return request({ url: "nfe/import-nfe-from-invoicy/", method: "POST", data })
}
export function updateNFeStatus(id) {
    return request({ url: `nfe/${id}/consult-status/` })
}
export function downaloadXML(id){
    return request({ url: `nfe/${id}/document/xml/` })
}
export function downaloadDANFE(id, paramas={}){
    return request({ url: `nfe/${id}/document/pdf/`, paramas })
}
export function createCCE(id, data){
    return request({ url: `nfe/${id}/cce/`, method:"POST", data })
}
export function getCCeHistory(id){
    return request({ url: `nfe/${id}/cce/history/` })
}
export function checkCreate(){
    return request({ url: `nfe/check-notes-quantity/`, method: "POST" })
}

export function getNFeBatch(){
    return request({ url: `export-nfe-batch/` })
}

export function createNFeBatch(data){
    return request({ url: `export-nfe-batch/`, method: "POST", data })
}
export function syncBacth(protocolNumber){
    return request({ url: `export-nfe-batch/${protocolNumber}/sync/` })
}
export function downloadBatch(protocolNumber){
    return request({ url: `export-nfe-batch/${protocolNumber}/download-batch/` })
}

export function aiReadProduct(data, params) {
    return request({ url: "nfe/ai-read-product/", method: "POST", data, params });
}
export function aiRegisterRecipient(data, params) {
    return request({ url: "nfe/ai-register-recipient/", method: "POST", data, params });
}
export function aiRegisterProduct(data, params) {
    return request({ url: "nfe/ai-register-product/", method: "POST", data, params });
}
export function aiRegisterProductsBatch(data, params) {
    return request({ url: "nfe/ai-register-products-batch/", method: "POST", data, params });
}
export function aiTranscribeAudioNFe(data, params) {
    return request({ url: "nfe/ai-transcribe-audio/", method: "POST", data, params });
}



// WEBPACK FOOTER //
// ./src/api/nfe/index.js